export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerSwitcher/GPlayerInfo.png?7c7bdeb511af604f75aad96fefce5340";